<template>
    <div>
        <hts-modal
            :show="show"
            :title="$t('labels.allotmentOrder')"
            :size="60"
            @close="close">
            <template #custom>
                <div class="flex justify-end mb-5 gap-3">
                    <div>
                        <p class="text-primary-700">
                            {{ $t('labels.totalProduction') }}:
                        </p>
                        <p class="text-primary-700">
                            {{ $t('labels.waitingForAllocation') }}:
                        </p>
                    </div>

                    <div>
                        <p class="text-primary-700">
                            {{ $formatters.formatNumber(productivityOrder) }}
                            <span>
                                {{ transportation ? (transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')) : '-' }}
                            </span>
                        </p>
                        <p class="text-primary-700">
                            {{ $formatters.formatNumber((waitingForAllocation || 0) - totalProductivityCreate) }}
                            <span>
                                {{ transportation ? (transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')) : '-' }}
                            </span>
                        </p>
                    </div>

                    <edit-productivity
                        :productivity-order="productivityOrder || 0"
                        :allotted="allotted || 0"
                        :order-id="orderId"
                        @update="(data) => emits('updateProductivityOrder', data)" />
                </div>

                <div class="w-full flex gap-2 justify-center">
                    <div class="w-[30%]">
                        {{ $t('labels.route') }} <span class="text-error-500">
                            *
                        </span>
                    </div>
                    <div class="w-[20%]">
                        {{ $t('labels.fleetVehicle') }}
                    </div>
                    <div class="w-[18%]">
                        {{ $t('labels.productivity') }} <span class="text-error-500">
                            *
                        </span>
                    </div>
                    <div class="w-[18%]">
                        {{ $t('labels.tripNumber') }} <span class="text-error-500">
                            *
                        </span>
                    </div>
                    <div class="w-[14%] min-w-[130px]" />
                </div>

                <div
                    v-for="(item, index) in allotment"
                    :key="index">
                    <div class="w-full flex gap-2 justify-start items-center mt-2">
                        <div class="flex flex-col items-start w-[30%]">
                            <hts-tooltip class="w-full">
                                <div>
                                    <span class="font-bold">
                                        {{ CNodeLocationNames }}
                                    </span>
                                </div>
                                <template #reference>
                                    <hts-form-input
                                        v-model="CNodeLocationNames"
                                        class="w-full"
                                        disabled />
                                </template>
                            </hts-tooltip>
                        </div>
                        <div class="flex flex-col justify-start items-start w-[20%]">
                            <hts-form-select
                                v-model="item._id"
                                v-model:text="item.name"
                                class="w-full"
                                :items="items"
                                :filterable="true"
                                key-id="_id"
                                key-label="name"
                                :disabled="item.route.length" />
                        </div>
                        <div class="w-[18%]">
                            <hts-form-input
                                v-model="item.productivity"
                                class="w-full"
                                type="number"
                                @change="changeProductivity(index)">
                                <template #suffix>
                                    <span>
                                        {{ transportation ? (transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')) : '-' }}
                                    </span>
                                </template>
                            </hts-form-input>
                        </div>
                        <div class="w-[18%]">
                            <hts-form-input
                                v-model="item.tripNumber"
                                disabled
                                class="w-full" />
                        </div>
                        <div class="w-[14%] min-w-[130px]">
                            <hts-dropdown
                                :options="tests"
                                placement="bottom-start"
                                :offset="[0, 15]"
                                label-key="label"
                                @click="(action) => dropdownAction(action, index)">
                                <template #reference>
                                    <hts-form-button
                                        icon-name="hi-chevron-down-icon"
                                        icon-position="right"
                                        class="w-full"
                                        size="small"
                                        color="info"
                                        type="button">
                                        Thao tác
                                    </hts-form-button>
                                </template>
                            </hts-dropdown>
                        </div>
                    </div>
                    <div
                        v-if="item.route.length"
                        class="w-full flex gap-4 justify-start items-center mt-2">
                        <div class="w-[30%]">
                            <p class="pl-5">
                                Chặng <span class="text-error-500">
                                    *
                                </span>
                            </p>

                            <div
                                v-for="routeItem in item.route"
                                :key="routeItem"
                                class="mt-2 box-border pl-5">
                                <hts-tooltip class="w-full">
                                    <div>
                                        <span class="font-bold">
                                            {{ routeItem.routeName }}
                                        </span>
                                    </div>
                                    <template #reference>
                                        <hts-form-input
                                            v-model="routeItem.routeName"
                                            class="w-full"
                                            size="small"
                                            disabled />
                                    </template>
                                </hts-tooltip>
                            </div>
                        </div>
                        <div class="w-[20%]">
                            <p class="pl-5">
                                {{ $t('labels.fleetVehicle') }}
                            </p>
                            <div
                                v-for="routeItem in item.route"
                                :key="routeItem"
                                class="mt-2 box-border px-2">
                                <hts-select-cooperator
                                    v-model="routeItem.fleetVehicle"
                                    v-model:name="routeItem.fleetVehicleName"
                                    type-cooperator="PARTNER"
                                    prop="vendor"
                                    label=""
                                    name-select="fleetVehicle"
                                    size="small"
                                    :creatable="true"
                                    :items="internalFleetVehicle"
                                    @change="
                                        () => {
                                            routeItem.contact = ''
                                            routeItem.contactName = ''
                                            fleetVehicleRouteChange(index)
                                        }
                                    " />
                            </div>
                        </div>
                        <div class="w-[30%]">
                            <p class="pl-5">
                                {{ $t('labels.vendorPriceModule.contact') }}
                            </p>
                            <div
                                v-for="routeItem in item.route"
                                :key="routeItem"
                                class="mt-2 box-border px-2">
                                <hts-select-cooperator-contact
                                    v-model="routeItem.contact"
                                    v-model:name="routeItem.contactName"
                                    :disabled="!routeItem.fleetVehicle || routeItem.fleetVehicle === 'internal'"
                                    :cooperator-id="routeItem.fleetVehicle"
                                    label=""
                                    key-label="namePhone"
                                    prop="contact"
                                    size="small"
                                    name-select="contact"
                                    :creatable="true"
                                    :param-prepare="routeItem.fleetVehicle" />
                            </div>
                        </div>
                        <div class="w-[20%]" />
                    </div>
                </div>

                <hts-form-button
                    class="mt-3"
                    icon-name="hi-plus-icon"
                    icon-position="right"
                    color="primary"
                    size="mini"
                    @click="addAllotment()">
                    {{ $t('labels.add') }}
                </hts-form-button>

                <div class="flex justify-end mt-5">
                    <hts-form-button
                        icon-name="hi-check-icon"
                        icon-position="right"
                        color="primary"
                        @click="saveAllotment()">
                        {{ $t('labels.save') }}
                    </hts-form-button>
                </div>
            </template>
        </hts-modal>
        <hts-modal
            :show="showConfirmModal"
            type="confirm"
            @close="showConfirmModal = false"
            @confirm="confirm">
            <p>
                Khi bạn lưu, {{ tripNumberCreate }} chuyến hàng tương ứng với {{ routeNumberCreate }} chặng hàng sẽ được tạo tự động cho đơn hàng {{ orderCode }}
            </p>
            <p>
                Đồng thời các đội xe được phân bổ cũng sẽ nhận được thông báo về chặng hàng
            </p>
        </hts-modal>

        <hts-modal
            size="small"
            :show="openModalLoading"
            :auto-close="true">
            <p>
                Đang phân bổ đơn hàng, vui lòng đợi trong giây lát
            </p>
            <progress class="progress w-full" />
        </hts-modal>

        <hts-modal
            :show="openModalSeparateRoute"
            size="medium"
            title="Tách chặng"
            @close="openModalSeparateRoute = false">
            <div>
                <hts-select-option
                    v-model="splitType"
                    :items="splitOptions" />
            </div>
            <div class="md:grid-cols-2 gap-2">
                <div>
                    <div
                        v-for="(item, index) in nodeRoute"
                        :key="index"
                        class="mb-2">
                        <hts-divider v-if="index > 0" />
                        <p>
                            Điểm tách chặng <span class="text-error-500">
                                *
                            </span>
                        </p>
                        <div class="flex gap-2 mb-2">
                            <hts-form-select
                                v-model="item.positionId"
                                v-model:text="item.label"
                                :items="CRouteSelect"
                                key-id="_id"
                                key-label="label"
                                name="role"
                                prop="role"
                                class="w-full"
                                @change="(val: any) => changeSeparateRoute(val, index)" />
                            <hi-x-circle-icon
                                class="h-6 w-6 ml-2 mt-3 text-error-500 cursor-pointer"
                                @click="($event: any) => deleteSeparateRoute($event, index)" />
                        </div>
                        <div>
                            <hts-form-select
                                v-model="item.splitTask"
                                label="Tác vụ tách chặng"
                                key-label="taskName"
                                :items="taskCanSplitWay(item.tasks)"
                                key-id="task" />
                        </div>
                    </div>
                </div>
            </div>

            <hts-form-button
                v-if="nodeRoute.length < CRouteSelect.length"
                class="mt-3"
                icon-name="hi-plus-icon"
                icon-position="right"
                color="primary"
                size="mini"
                @click="addSeparateRoute()">
                {{ $t('labels.add') }}
            </hts-form-button>

            <div class="flex justify-end mt-5">
                <hts-form-button
                    icon-name="hi-check-icon"
                    icon-position="right"
                    color="primary"
                    @click="confirmSeparateRoute()">
                    {{ $t('labels.save') }}
                </hts-form-button>
            </div>
        </hts-modal>

        <hts-modal
            v-model="validateModalVisible"
            :auto-close="true"
            class-name="bg-yellow-300">
            <p>
                Đội xe nội bộ không đủ năng lực để thực hiện {{ validateModalContent.totalJourney - validateModalContent.canAssignCount }}/{{
                    validateModalContent.totalJourney
                }}
                chặng được phân bổ.
            </p>
            <p>
                Vui lòng điều chỉnh sản lượng phân bổ hoặc thao tác điều xe thủ công.
            </p>
            <div class="max-h-[400px] overflow-auto scrollbar">
                <template
                    v-for="(item, index) in validateModalContent.scheduleData"
                    :key="index">
                    <hts-divider v-if="index > 0" />
                    <div
                        v-if="item.vehicle"
                        class="text-blue-500">
                        <b class="mr-1">
                            Chặng {{ item.journey?.code }} điều xe {{ item.vehicle.licensePlate }}
                        </b>
                    </div>
                    <div
                        v-else
                        class="text-red-500">
                        <div>
                            <b>
                                Chặng {{ item.journey?.code }}
                            </b>
                        </div>
                        <p>
                            Các xe phù hợp và lý do không phân bổ được:
                        </p>
                        <div v-if="Array.isArray(item.errors) && item.errors.length">
                            <template
                                v-for="(error, errorI) in item.errors"
                                :key="errorI">
                                <p>
                                    <b class="mr-1">
                                        {{ error.vehicle.licensePlate }}:
                                    </b>
                                    <span>
                                        {{ error.error }}
                                    </span>
                                </p>
                            </template>
                        </div>
                        <div v-else>
                            Không tìm được xe phù hợp
                        </div>
                    </div>
                </template>
            </div>
            <div class="flex justify-end mt-5">
                <hts-form-button
                    icon-name="hi-check-icon"
                    icon-position="right"
                    :outline="false"
                    color="primary"
                    @click="confirm(true)">
                    Điều xe
                </hts-form-button>
                <hts-form-button
                    color="disable"
                    @click="validateModalVisible = false">
                    Thay đổi phân bổ
                </hts-form-button>
            </div>
        </hts-modal>

        <hts-modal
            :show="openModalChooseContainer"
            type="confirm"
            @close="openModalChooseContainer = false"
            @confirm="openModalChooseContainer = false">
            <table class="w-full border-collapse border border-gray-300">
                <thead>
                    <tr class="bg-gray-100">
                        <th class="w-16 border border-gray-300 p-2">
                            Chuyến
                        </th>
                        <th class="border border-gray-300 p-2">
                            Số container
                        </th>
                        <th
                            v-if="mergeContainer"
                            class="border border-gray-300 p-2">
                            Số container
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr
                        v-for="(item, index) in allotment[indexChooseContainer]?.containerNumbers"
                        :key="index">
                        <td class="border border-gray-300 p-2 text-center">
                            {{ index + 1 }}
                        </td>

                        <td class="border border-gray-300 p-2">
                            <hts-form-select
                                v-model="item[0].id"
                                v-model:text="item[0].containerNumber"
                                class="w-full"
                                :items="orderContainerNumbers"
                                :filterable="true"
                                key-id="_id"
                                key-label="containerNumber"
                                :prop="`containerNumber_${index}_0`"
                                :name="`containerNumber_${index}_0`"
                                creatable
                                @createNew="handleCreateNewContainerNumber(index, 0)" />
                        </td>
                        <td
                            v-if="mergeContainer"
                            class="border border-gray-300 p-2">
                            <hts-form-select
                                v-model="item[1].id"
                                v-model:text="item[1].containerNumber"
                                class="w-full"
                                :items="orderContainerNumbers"
                                :filterable="true"
                                key-id="_id"
                                key-label="containerNumber"
                                :prop="`containerNumber_${index}_1`"
                                :name="`containerNumber_${index}_1s`"
                                creatable
                                @createNew="handleCreateNewContainerNumber(index, 1)" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </hts-modal>

        <hts-modal
            :show="openCreateNewContainerNumber"
            type="confirm"
            title="Thêm mới số container"
            @close="openCreateNewContainerNumber = false"
            @confirm="submitCreateNewContainerNumber">
            <hts-form-input
                v-model="newContainerNumber"
                class="w-full" />
        </hts-modal>

        <edit-shipping-plan
            ref="editShippingPlan"
            @updateShippingPlan="handleEditShippingPlan" />
    </div>
</template>
<script setup lang="ts">
import cloneDeep from 'lodash-es/cloneDeep'
import EditProductivity from '../component/edit-productivity.vue'
import { nodeLocationNames, nodeNames } from '../plugins/index'
import EditShippingPlan from './edit-shipping-plan.vue'
const { $formatters } = useNuxtApp()

const props = defineProps({
  order: {
    type: Object
  },
  orderId: {
    type: Number,
    required: true
  },
  orderCode: {
    type: String,
    required: true
  },
  productivityOrder: {
    type: Number,
    required: true
  },
  waitingForAllocation: {
    type: Number,
    required: true
  },
  transportation: {
    type: String,
    required: true
  },
  mergeContainer: {
    type: Boolean,
    required: true
  },
  headContainer: {
    type: Boolean,
    required: true
  },
  positions: {
    type: Array,
    required: true
  },
  chargeName: {
    type: String
  },
  allotted: {
    type: Number,
    required: true
  }
})

const emits = defineEmits(['update', 'updateProductivityOrder', 'reload-container-number'])

const { order, orderId, productivityOrder, mergeContainer, headContainer, orderCode, waitingForAllocation, chargeName, allotted } = toRefs(props)

const positions: any = toRefs(props).positions

const show = ref<boolean>(false)
const showConfirmModal = ref<boolean>(false)
const tripNumberCreate = ref(0)
const routeNumberCreate = ref(0)
const openModalLoading = ref<boolean>(false)
const openModalSeparateRoute = ref<boolean>(false)
const openModalChooseContainer = ref<boolean>(false)
const indexSeparateRoute = ref(0)
const indexChooseContainer = ref(0)
const indexChooseContainer1ForCreate = ref(0)
const indexChooseContainer2ForCreate = ref(0)
const openCreateNewContainerNumber = ref<boolean>(false)
const totalProductivityCreate = ref(0)
const orderContainerNumbers = ref<{ [key: string]: any }[]>([])
const newContainerNumber = ref('')

const containerNumbersDefaults = computed(() => {
  if (mergeContainer.value) {
    return [
      { id: '', containerNumber: '' },
      { id: '', containerNumber: '' }
    ]
  }

  return [{ id: '', containerNumber: '' }]
})

// ref HTML element
const editShippingPlan = ref()

const nodeRoute = ref([
  {
    positionId: '',
    label: '',
    index: 0,
    splitTask: '',
    tasks: []
  }
])

const internalFleetVehicle = [
  {
    _id: 'internal',
    name: $t('labels.internal')
  }
]

const CNodeLocationNames = computed(() => nodeLocationNames(positions.value))

const CNodeNames = computed(() => nodeNames(positions.value))

// item đã phân bổ
const allotment = ref<{ [key: string]: any }[]>([])

// toàn bộ item
const allotmentDatas = ref<{ [key: string]: any }[]>([])

const items = computed(() => {
  // const idList = allotment.value.map((item: any) => item._id)
  const idList: string[] = []
  return allotmentDatas.value.filter((item) => !idList.includes(item._id) && item.type !== 'other')
})

// tạo đơn hàng mới hoặc edit đơn hàng để lấy thông tin task tách chặng
const taskCanSplitWay = (tasks: any) => {
  if (!Array.isArray(tasks) || !tasks.length) {
    return []
  }
  return tasks.filter((item: any) => item.canSplitWay)
}

// add
const addAllotment = () => {
  if (!allotment.value || !Array.isArray(allotment.value) || !allotment.value.length) {
    formatAllotment()
    return
  }

  // if (allotment.value.length >= allotmentDatas.value.length) {
  //   return
  // }

  allotment.value.push({
    routeName: CNodeNames.value,
    name: '',
    _id: '',
    productivity: null,
    tripNumber: null,
    nodeRoute: [
      {
        positionId: '',
        label: '',
        index: 0
      }
    ],
    route: [],
    containerNumbers: []
  })
}

const setContainerNumbers = (index: number, data: { [key: string]: any }[]) => {
  if (!allotment.value[index]) {
    return
  }
  allotment.value[index].containerNumbers = data
}

// thay đổi sản lượng => tính lại số chuyến
const changeProductivity = (index: number | undefined) => {
  let totalProductivity = 0
  allotment.value.forEach((item: any) => {
    const { productivity } = item
    totalProductivity += productivity
  })

  totalProductivityCreate.value = totalProductivity

  if (typeof index !== 'number') {
    return
  }

  if (mergeContainer.value) {
    if (allotment.value[index].productivity % 2 !== 0) {
      allotment.value[index].tripNumber = null
      setContainerNumbers(index, [cloneDeep(containerNumbersDefaults.value)])
      return
    }
    allotment.value[index].tripNumber = allotment.value[index].productivity ? allotment.value[index].productivity / 2 : allotment.value[index].productivity
  } else {
    allotment.value[index].tripNumber = allotment.value[index].productivity
  }

  const defaultConts = Array.from({ length: allotment.value[index].tripNumber }, () => {
    return cloneDeep(containerNumbersDefaults.value)
  })

  setContainerNumbers(index, defaultConts)
}

const saveAllotment = () => {
  const productivity = allotment.value.reduce((accumulator, currentValue) => {
    return accumulator + currentValue.productivity
  }, 0)

  if (!waitingForAllocation?.value || waitingForAllocation?.value < 0) {
    process.client && $toast().error($t('labels.notProductivityWaiting'))
    return
  }

  if (productivity > waitingForAllocation.value) {
    process.client && $toast().error('Sản lượng phân bổ vượt quá sản lượng chờ phân bổ của đơn hàng')
    return
  }

  let hasError = false

  let totalProductivity = 0
  let totalRoute = 0

  allotment.value.forEach((item: any) => {
    if (hasError) {
      return
    }

    if (!item._id && !item.route.length) {
      process.client && $toast().error('Vui lòng chọn đội xe phân bổ đơn hàng')
      hasError = true
      return
    }

    if (item.route.length) {
      item.route.forEach((item2: any) => {
        if (hasError) {
          return
        }
        if (item2.fleetVehicle && !item2.contact && item2.fleetVehicle !== 'internal') {
          process.client && $toast().error(`Vui lòng chọn thông liên hệ cho đội xe ${item2.fleetVehicleName}`)
          hasError = true
        }
      })
      if (hasError) {
        return
      }
    }

    if (!item.productivity || item.productivity <= 0) {
      process.client && $toast().error($t('labels.productivityIsRequired'))
      hasError = true
      return
    }

    const { productivity } = item
    totalProductivity += productivity

    if (mergeContainer.value) {
      if (productivity % 2 !== 0) {
        process.client && $toast().error($t('labels.productivityMustEvenNumber'))
        hasError = true
        return
      }
      tripNumberCreate.value = totalProductivity / 2
      totalRoute += (productivity / 2) * (item.route.length || 1)
    } else {
      tripNumberCreate.value = totalProductivity
      totalRoute += productivity * (item.route.length || 1)
    }
  })

  routeNumberCreate.value = totalRoute

  if (hasError) {
    return
  }

  showConfirmModal.value = true
}

const validateModalVisible = ref(false)
const validateModalContent = reactive<any>({ canAssignAll: true, canAssignCount: 0, sheduleData: [], totalJourney: 0 })

const confirm = async (force: boolean = false) => {
  if (!orderId?.value) {
    process.client && $toast().error($t('labels.notFoundOrder'))
    return
  }

  validateModalVisible.value = false
  openModalLoading.value = true
  showConfirmModal.value = false

  const api = $urlPartner.order.allotment.add
  const body: { [key: string]: any } = {
    mergeContainer: mergeContainer.value,
    headContainer: headContainer.value,
    allotment: allotment.value,
    force
  }
  const res: any = await $api(api, { body, uriParams: { ORDER_ID: orderId.value } })
  const resData: any = res.data.value
  if (resData?.success) {
    emits('update', resData.data)
    close()
    process.client && $toast().success($t('labels.allotmentSuccess'))
  } else {
    openModalLoading.value = false

    const { canAssignAll, canAssignCount, scheduleData, totalJourney } = resData?.errors || {}
    if (totalJourney) {
      Object.assign(validateModalContent, { canAssignAll, canAssignCount, scheduleData, totalJourney })
      validateModalVisible.value = true
    }
  }
}

const open = (allotmentData: { [key: string]: any }[]) => {
  allotmentDatas.value = allotmentData
  formatAllotment()
  show.value = true
  getOrderContainerNumbers()
}

const getOrderContainerNumbers = async () => {
  if (!orderId.value) {
    return
  }

  const url = $urlPartner.order.order.getContainerNumbers

  const data: any = await $api(url, { uriParams: { ID: orderId.value } })
  const resData: any = data?.data?.value

  if (resData?.success) {
    orderContainerNumbers.value = resData.data.containerNumbers || []
  } else {
    orderContainerNumbers.value = []
  }
}

const close = () => {
  formatAllotment()
  show.value = false
  showConfirmModal.value = false
  openModalLoading.value = false
}

const formatAllotment = () => {
  allotment.value = [
    {
      routeName: CNodeNames.value,
      name: '',
      _id: '',
      productivity: null,
      tripNumber: null,
      nodeRoute: [
        {
          positionId: '',
          label: '',
          index: 0
        }
      ],
      route: [],
      containerNumbers: []
    }
  ]
  changeProductivity(undefined)
}

const addSeparateRoute = () => {
  if (nodeRoute.value.length >= CRouteSelect.value.length) {
    return
  }
  nodeRoute.value.push({
    positionId: '',
    label: '',
    index: 0,
    tasks: [],
    splitTask: ''
  })
}

const confirmSeparateRoute = () => {
  let hasError = false

  if (nodeRoute.value.length === 1 && !nodeRoute.value[0]?.positionId) {
    allotment.value[indexSeparateRoute.value].nodeRoute = [
      {
        positionId: '',
        label: '',
        index: 0,
        tasks: [],
        splitTask: ''
      }
    ]
    allotment.value[indexSeparateRoute.value].route = []
    openModalSeparateRoute.value = false
    return
  }

  const listIds = [] as string[]

  nodeRoute.value.forEach((item: any) => {
    if (hasError) {
      return
    }

    if (!item.positionId) {
      process.client && $toast().error('Vui lòng chọn điểm tách chặng')
      hasError = true
    }

    if (listIds.includes(item.positionId)) {
      process.client && $toast().error('Điểm tách chặng không được trùng nhau')
      hasError = true
    }

    listIds.push(item.positionId)
  })

  if (hasError) {
    return hasError
  }

  const routeArrays = [] as any[]
  let index = 0
  positions.value.forEach((item: any) => {
    const data = {
      ...item,
      label: item.nodeLocationName
    }
    if (!routeArrays[index]) {
      routeArrays[index] = []
    }

    routeArrays[index].push(data)

    if (listIds.includes(item._id)) {
      index++
      if (!routeArrays[index]) {
        routeArrays[index] = []
      }

      routeArrays[index].push(data)
    }
  })

  allotment.value[indexSeparateRoute.value].nodeRoute = nodeRoute.value
  allotment.value[indexSeparateRoute.value].route = routeArrays.map((items) => {
    const labels = items.map((obj: any) => obj.label)
    return {
      routeName: labels.join(' >>> '),
      route: items,
      fleetVehicle: '',
      fleetVehicleName: '',
      contact: '',
      contactName: ''
    }
  })
  allotment.value[indexSeparateRoute.value].splitTask = splitTask.value
  allotment.value[indexSeparateRoute.value].splitType = splitType.value
  allotment.value[indexSeparateRoute.value]._id = ''
  allotment.value[indexSeparateRoute.value].name = ''

  nextTick(() => {
    splitTask.value = null
    splitType.value = 'all'
    splitTasks.value = []
    openModalSeparateRoute.value = false
  })
}

const changeSeparateRoute = (val: any[], index: number) => {
  if (!val || !val.length) {
    nodeRoute.value[index].index = 0
    return
  }
  splitTask.value = null
  nodeRoute.value[index].tasks = val[0].tasks
  nodeRoute.value[index].index = val[0].index
}

const deleteSeparateRoute = (e: Event, index: number) => {
  e.preventDefault()
  e.stopPropagation()

  splitTask.value = null
  if (index < 0 || index >= nodeRoute.value.length) {
    return
  }
  nodeRoute.value[index].tasks = []
  nodeRoute.value.splice(index, 1)
  if (!nodeRoute.value || !Array.isArray(nodeRoute.value) || !nodeRoute.value.length) {
    nodeRoute.value = [
      {
        positionId: '',
        label: '',
        index: 0,
        tasks: [],
        splitTask: ''
      }
    ]
  }
}

const CRouteSelect = computed(() => {
  if (Array.isArray(positions?.value) && positions?.value?.length && positions?.value?.length >= 2) {
    const data = positions.value.filter((item: any, index: number) => {
      if (index !== 0 && index !== positions.value.length - 1 && item.canSplitWay) {
        return item
      }
      return undefined
    })
    data.map((item: any) => {
      item.label = item.nodeLocationName + ' Vị trí' + ` ${item.index}`
      return item
    })
    return data
  } else {
    return []
  }
})

// những chặng có chung 1 đội xe thì chuyến cũng là đội xe đó
const fleetVehicleRouteChange = (index: number) => {
  const isAllEqual = allotment.value[index].route.every((item: any, index: number, array: any[]) => item.fleetVehicle === array[0].fleetVehicle)
  if (isAllEqual) {
    allotment.value[index].name = allotment.value[index].route[0].fleetVehicleName
    allotment.value[index]._id = allotment.value[index].route[0].fleetVehicle
  } else {
    allotment.value[index].name = ''
    allotment.value[index]._id = ''
  }
}

const handleOpenModalSeparateRoute = (index: number) => {
  nodeRoute.value = cloneDeep(allotment.value[index].nodeRoute)
  indexSeparateRoute.value = index
  openModalSeparateRoute.value = true
}

const handleChooseContainers = (index: number) => {
  indexChooseContainer.value = index
  openModalChooseContainer.value = true
}

const deleteAllotment = (index: number) => {
  if (index < 0 || index >= allotment.value.length) {
    return
  }
  allotment.value.splice(index, 1)
  changeProductivity(undefined)
  if (!allotment.value || !Array.isArray(allotment.value) || !allotment.value.length) {
    formatAllotment()
  }
}

const editShipingPlan = (index: number) => {
  const positions = allotment.value[index]?.positions || []
  const manualPlanning = allotment.value[index]?.manualPlanning || []
  // const travelDetails = allotment.value[index]?.travelDetails || []
  const condition = allotment.value[index]?.condition || []
  const waitingTasks = allotment.value[index]?.waitingTasks || []

  let data: { [key: string]: any } | null = null

  if (positions && positions.length) {
    data = {
      positions,
      manualPlanning,
      // travelDetails,
      condition,
      waitingTasks
    }
  }

  if (editShippingPlan?.value && order?.value) {
    editShippingPlan.value.open(order.value, index, data)
  }
}

const handleEditShippingPlan = (value: { [key: string]: any }) => {
  const positions = value?.positions || []
  const manualPlanning = value?.manualPlanning || []
  // const travelDetails = value?.travelDetails || []
  const condition = value?.condition || []
  const waitingTasks = value?.waitingTasks || []
  const solution = value?.solution || ''

  if (positions && positions.length) {
    allotment.value[value.index].positions = positions
    allotment.value[value.index].manualPlanning = manualPlanning
    // allotment.value[value.index].travelDetails = travelDetails
    allotment.value[value.index].condition = condition
    allotment.value[value.index].waitingTasks = waitingTasks
    allotment.value[value.index].solution = solution
  }
}

const tests = [
  {
    icon: 'hi-adjustments-horizontal-icon',
    label: 'Chọn container',
    class: 'text-gray-600  hover:text-gray-500',
    click: handleChooseContainers
  },
  {
    icon: 'hi-adjustments-horizontal-icon',
    label: 'Tách chặng',
    class: 'text-gray-600  hover:text-gray-500',
    click: handleOpenModalSeparateRoute
  },
  {
    icon: 'hi-pencil-square-icon',
    label: $t('labels.planningModify'),
    class: 'text-gray-600  hover:text-gray-500',
    click: editShipingPlan
  },
  {
    icon: 'hi-trash-icon',
    label: $t('labels.delete'),
    class: 'text-error-600 hover:text-error-500',
    click: deleteAllotment
  }
]

const dropdownAction = (action: { [key: string]: any }, index: number) => {
  if (action) {
    action.click(index)
  }
}

const handleCreateNewContainerNumber = (index1: number, index2: number) => {
  openCreateNewContainerNumber.value = true
  indexChooseContainer1ForCreate.value = index1
  indexChooseContainer2ForCreate.value = index2
}

const submitCreateNewContainerNumber = async () => {
  if (!newContainerNumber.value) {
    process.client && $toast().error('Vui lòng nhập số container để thêm mới')
  }

  const url = $urlPartner.order.order.addContainerNumber
  const body: { [key: string]: any } = {
    containerNumber: newContainerNumber.value
  }
  const res: any = await $api(url, { body, uriParams: { ID: orderId.value } })

  const resData: any = res?.data?.value

  if (resData.success) {
    openCreateNewContainerNumber.value = false
    process.client && $toast().success('Thêm số container thành công')
    allotment.value[indexChooseContainer.value].containerNumbers[indexChooseContainer1ForCreate.value][indexChooseContainer2ForCreate.value].id =
      resData.data._id

    allotment.value[indexChooseContainer.value].containerNumbers[indexChooseContainer1ForCreate.value][indexChooseContainer2ForCreate.value].containerNumber =
      resData.data.containerNumber

    getOrderContainerNumbers()

    emits('reload-container-number')
  }
}

const splitOptions = ref([
  { name: 'Đổi xe', value: 'all' },
  { name: 'Cắt Mooc', value: 'only_head' }
])
const splitType = ref('all')
const splitTasks = ref([])
const splitTask = ref(null)
defineExpose({ open })
</script>
